import { Button, Group, Modal, Select, Stack, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";

interface BulkSetTypeModalProps {
	opened: boolean;
	count: number;
	loading: boolean;
	licenseTypes: { value: string; label: string }[];
	onClose: () => void;
	onSubmit: (licenseTypeId: string) => void;
}

function BulkSetTypeModal({
	opened,
	count,
	loading,
	licenseTypes,
	onClose,
	onSubmit,
}: BulkSetTypeModalProps) {
	const form = useForm({
		initialValues: { licenseTypeId: "" },
		validate: {
			licenseTypeId: (value) => (value ? null : "License type is required"),
		},
	});

	useEffect(() => {
		if (opened) {
			form.reset();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [opened]);

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title="Set License Type"
			size="md">
			<form
				onSubmit={form.onSubmit((values) => onSubmit(values.licenseTypeId))}>
				<Stack gap="md">
					<Text>
						Set the license type of {count} selected license(s). They will be
						billed at the new type's price.
					</Text>

					<Select
						label="License Type"
						placeholder="Select a license type"
						data={licenseTypes}
						required
						{...form.getInputProps("licenseTypeId")}
					/>

					<Group
						justify="flex-end"
						mt="lg">
						<Button
							variant="light"
							onClick={onClose}>
							Cancel
						</Button>
						<Button
							type="submit"
							loading={loading}>
							Set Type
						</Button>
					</Group>
				</Stack>
			</form>
		</Modal>
	);
}

export default BulkSetTypeModal;
